import React, { Component } from "react";

import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg,
  CInput,
  CLink,
  CRow,
  CSpinner
} from "@coreui/react";
import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

class CommunityContentLives extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // activity: null,
      // tab: 1,
      discipline_id: null,
      disciplines: [{ name: "Carregando", id: null }],
      publishLoading: false,
      start_allocation: "",
      end_allocation: "",
      title: ""
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.handleDisciplines();
    this.handleLives();
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  handleDisciplines() {
    const { id } = this.props.match.params;

    axios
      .get(`${URL.api}community/room/singleView/${id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (!this.props.isRoom) {
            const roomUser = resp.data.data.room_user.find(
              roomUser => roomUser.user_id === this.props.user.user.id
            ).id;
            const disciplines = resp.data.data.room_user_discipline
              .filter(discipline => discipline.room_user_id === roomUser)
              .map(discipline => ({
                id: resp.data.data.room_discipline.find(
                  roomDiscipline =>
                    roomDiscipline.id === discipline.room_discipline_id
                ).discipline_id,
                name: discipline.discipline_name
              }));

            this.setState({
              room: resp.data.data.room,
              disciplines,
              discipline_id: disciplines[0]?.id || null
            });
          }
        },
        error => {
          this.error("Não foi possível buscar as disciplinas");
        }
      );
  }

  handleLives() {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}activity/activity/filter`,
        { user: this.props.user.user.id, room: id, types: [2] },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({ lives: resp.data.data, loading: false });
        },
        error => {
          this.error("Não foi possível buscar as atividade");
        }
      );
  }

  insertLive() {
    this.setState({ publishLoading: true });

    const obj = {
      user_id: this.props.user.user.id,
      name: this.state.title,
      room_list: [
        {
          start_allocation: this.state.start_allocation,
          end_allocation: this.state.end_allocation,
          room_id: this.props.match.params.id
        }
      ],
      type_id: 2,
      private: false,
      discipline_id: this.state.discipline_id,
      result_type: "SEMPRE"
    };

    if (this.state.title === "") {
      toastr.error("Atenção", "Digite um nome para o evento.");
      this.setState({ publishLoading: false });
    } else if (this.state.start_allocation === "") {
      toastr.error("Atenção", "Escolha um início para o evento.");
      this.setState({ publishLoading: false });
    } else if (this.state.end_allocation === "") {
      toastr.error("Atenção", "Escolha um fim para o evento.");
      this.setState({ publishLoading: false });
    } else {
      axios
        .post(`${URL.api}activity/activity/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            let obj = {
              user_id: this.props.user.user.id,
              title: "Nova atividade ao vivo alocada",
              type: "notification",
              activities: [resp.data.data],
              roles: [
                {
                  room_id: this.props.match.params.id,
                  role_id: 7,
                  group_id: this.state.room.group_id,
                  region_id: this.state.room.region_id,
                  school_id: this.state.room.school_id
                }
              ]
            };

            axios
              .post(`${URL.api}communication/notice/insert`, obj, {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(
                () => {
                  this.setState({
                    title: "",
                    start_allocation: "",
                    end_allocation: "",
                    publishLoading: false
                  });
                  window.open(`/activity/live/${resp.data.data}`, "_blank");
                  // this.props.history.push("/activity/live/" + resp.data.data);
                  this.handleLives();
                },
                error => {
                  this.error("Não foi possível criar nova atividade!");
                }
              );
          },
          error => {
            this.error("Não foi possível criar nova atividade!");
            this.setState({ publishLoading: false });
          }
        );
    }
  }

  render() {
    const { lives } = this.state;

    return (
      <>
        {this.props.hasPrivilege && (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <CInput
                value={this.state.title}
                onChange={e => this.setState({ title: e.target.value })}
                placeholder="Nome do evento ao vivo"
                type="text"
                className="border-0 p-0 shadow-none"
                style={{ fontSize: "1rem", fontWeight: "bold", flex: 1 }}
              />
              <CDropdown
                className="ml-2"
                style={{ border: "1px solid #d8dbe0", borderRadius: "0.25rem" }}
              >
                <CDropdownToggle>
                  <span className="mr-1">
                    {
                      this.state.disciplines.find(
                        discipline => discipline.id === this.state.discipline_id
                      )?.name
                    }
                  </span>
                </CDropdownToggle>
                <CDropdownMenu>
                  {this.state.disciplines.map(discipline => (
                    <CDropdownItem
                      key={discipline.id}
                      onClick={() =>
                        this.setState({ discipline_id: discipline.id })
                      }
                      active={this.state.discipline_id === discipline.id}
                    >
                      {discipline.name}
                    </CDropdownItem>
                  ))}
                </CDropdownMenu>
              </CDropdown>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  <div className="mb-3 font-weight-bold">Início</div>
                  <Form.Control
                    type="datetime-local"
                    value={this.state.start_allocation}
                    step="1"
                    onChange={e =>
                      this.setState({ start_allocation: e.target.value })
                    }
                  />
                </CCol>
                <CCol>
                  <div className="mb-3 font-weight-bold">Fim</div>
                  <Form.Control
                    type="datetime-local"
                    value={this.state.end_allocation}
                    step="1"
                    onChange={e =>
                      this.setState({ end_allocation: e.target.value })
                    }
                  />
                </CCol>
              </CRow>
            </CCardBody>
            <CCardFooter className="d-flex justify-content-end">
              <div className="d-flex align-items-center">
                <CButton
                  color="primary"
                  onClick={() => this.insertLive()}
                  style={{ position: "relative" }}
                  className="d-flex justify-content-center align-items-center"
                >
                  <span
                    style={this.state.publishLoading ? { opacity: 0 } : null}
                  >
                    Criar
                  </span>
                  {this.state.publishLoading && (
                    <CSpinner
                      color="white"
                      size="sm"
                      style={{ position: "absolute" }}
                    />
                  )}
                </CButton>
              </div>
            </CCardFooter>
          </CCard>
        )}
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            {lives &&
            lives.filter(live =>
              live.name.toLowerCase().includes(this.props.search.toLowerCase())
            ).length > 0 ? (
              <CRow>
                {lives
                  .filter(live =>
                    live.name
                      .toLowerCase()
                      .includes(this.props.search.toLowerCase())
                  )
                  .map(live => (
                    <CCol key={live.id} sm="6" lg="4">
                      <CLink
                        className="not-link"
                        to={`/activity/live/${live.allocation_id}`}
                        target="_blank"
                      >
                        <CCard className="card-room-activity">
                          <CCardBody className="d-flex align-items-center">
                            <div
                              className="bg-white mw-100"
                              style={{ height: "60px", width: "60px" }}
                            >
                              <CImg
                                src={
                                  live.user_photo
                                    ? URL.img + live.user_photo
                                    : `${URL.img}uploads/users/profileEmpty.jpg`
                                }
                                className="rounded-circle"
                                style={{ height: "60px", width: "60px" }}
                              />
                            </div>
                            <div className="d-flex flex-column justify-content-center ml-3 flex-1 text-ellipsis">
                              <h5 className="text-overflow mb-1 text-ellipsis">
                                {live.name}
                              </h5>
                              <div className="text-ellipsis">
                                {live.user_name}
                              </div>
                              <div className="text-ellipsis">
                                {new Date(live.activity_end) < new Date() ? (
                                  <CBadge
                                    color="secondary"
                                    className="d-inline mt-1"
                                  >
                                    Encerrada
                                  </CBadge>
                                ) : new Date(live.activity_start) >
                                  new Date() ? (
                                  <CBadge
                                    color="light"
                                    className="d-inline mt-1"
                                  >
                                    Em breve
                                  </CBadge>
                                ) : (
                                  <CBadge
                                    color="danger"
                                    className="d-inline mt-1"
                                  >
                                    Ao vivo
                                  </CBadge>
                                )}
                              </div>
                            </div>
                          </CCardBody>
                        </CCard>
                      </CLink>
                    </CCol>
                  ))}
              </CRow>
            ) : (
              <div className="d-flex align-items-center justify-content-center p-3 text-muted">
                Nenhum evento ao vivo acontecendo no momento
              </div>
            )}
          </React.Fragment>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentLives);
